/**
 * Script Name: Submenu Toggle Script
 * Version: 1.0.0
 * Description: Handles submenu toggling functionality in the header.
 * Author: Wubbe
 * Date: December 14, 2023
 */

import './header-1-0';
var header = document.querySelector(".header");

//show or hidden block submenu
const submenu = document.querySelectorAll(".header .menu-item-has-children");
// const overlay = document.querySelector(".header__overlay");

submenu.forEach((menuItem) => {
    menuItem.addEventListener("click",(e)=>{
        const clickedSubmenu = e.currentTarget;
        if (!clickedSubmenu.classList.contains("is-active")) {
            submenu.forEach(sub => sub.classList.remove("is-active"));
            clickedSubmenu.classList.add("is-active");
            // Toggle overlay or any related actions if needed
        } else {
            clickedSubmenu.classList.remove("is-active");
            // Toggle overlay or any related actions if needed
        }
    });
    
});
document.addEventListener('click', function(e) {
    const clickedMenuItem = e.target.closest(".menu-item-has-children");
    if (!clickedMenuItem) {
        submenu.forEach(sub => sub.classList.remove("is-active"));
    }
});

// scroll check

var isScrolled = false;

// Function to check scroll position and add/remove class
function onScroll() {
    if (window.scrollY > 200) {
        if (!isScrolled) {
            header.classList.add("header-scrolled");
            isScrolled = true; // Update the state to indicate that the class is added
        }
    } else {
        if (isScrolled) {
            header.classList.remove("header-scrolled");
            isScrolled = false; // Update the state to indicate that the class is removed
        }
    }
}

// Add scroll event listener
window.addEventListener("scroll", onScroll);